module.exports = __webpack_public_path__ + "img/icon_result-pending.16821229.svg";